import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
  PaginatedResponse,
} from 'api';
import { axiosInstance } from 'api/axios-instance';
import { DashboardParmas } from 'types/dashboard';
export interface DashBoardListParams extends PaginatedRequestParams {
  Name?: string;
  Email?: string;
  PhoneNumber?: string;
  retry?: boolean;
  created_at_from?: string; // ISO8601_FORMAT
  created_at_to?: string; // ISO8601_FORMAT
}
export type fetchFalg = {
  Flag: string;
};
export type DashBoardResponse = PaginatedResponse<DashboardParmas>;

export const DashBoardApiService = () => {
  const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
  const createDashBoard = async (formData: FormData) => {
    const response = await axiosInstance.post(
      `${baseURL}/ClientDocuments/UploadRequiredDocuments`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };
  const getDashBoard = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<DashBoardResponse>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/GetClientRequiredDocumentType`,
      params,
    });

    return response.data;
  };
  const getLegalDocuments = async (
    id: string,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL1 = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL1}/ClientDocuments/GetClientRequiredDocumentType/${id}`,
    });

    return response.data;
  };
  const CreateselectCompany = async (
    payload: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL1 = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL1}/Admin/UpdateCompanyIsDefault`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const uploadImageDocument = async (
    id: string,
    formData: FormData,
  ): Promise<any> => {
    const baseURL1 = process.env.REACT_APP_PARTNERPLUS_API_UPLOAD_BASE_URL;
    const response = await axiosInstance.post(
      `${baseURL1}/upload?companyId=${id}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };
  const GetNotifications = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/AdminDashboard/GetNotifications`,
      params,
    });

    return response.data;
  };
  const GetNotificationsCount = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/AdminDashboard/GetNotificationsCount`,
      params,
    });

    return response.data;
  };
  const NotificationSeen = async (formData: FormData) => {
    const baseURL1 = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await axiosInstance.post(
      `${baseURL1}/AdminDashboard/UpdateNotificationSeen`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };
  const notificatioRead = async (formData: FormData) => {
    const baseURL1 = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await axiosInstance.post(
      `${baseURL1}/AdminDashboard/UpdateNotificationRead`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };
  
return {
    getDashBoard,
    createDashBoard,
    CreateselectCompany,
    getLegalDocuments,
    uploadImageDocument,
    GetNotifications,
    GetNotificationsCount,
    NotificationSeen,
    notificatioRead,
  };
};
